import { useState, useEffect } from 'react';
import { ref as storageRef, getDownloadURL, getStorage } from 'firebase/storage';

const AudioLoader = ({ storagePath }) => {
    const [audioUrl, setAudioUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // 1. Reset state for new path
        setLoading(true);
        setError(null);
        setAudioUrl(null);

        // 2. Create a reference to the file in Firebase Storage
        const storage = getStorage();
        const fileRef = storageRef(storage, storagePath);

        // 3. Get the public download URL
        getDownloadURL(fileRef)
            .then((url) => {
                setAudioUrl(url);
                setLoading(false);
            })
            .catch((err) => { // eslint-disable-line no-unused-vars

                setError("Error loading audio.");
                setLoading(false);
            });
    }, [storagePath]); // Re-run effect whenever the path changes

    if (loading) {
        return <div>Loading audio...</div>;
    }

    if (error) {
        return <div style={{ color: 'red' }}>{error}</div>;
    }

    return (
        <audio src={audioUrl}
            alt={`Audio aid for sentence`}
            controls preload="none" style={{ width: 160 }} />
    );
};

export default AudioLoader;